import { render, staticRenderFns } from "./BarraDeCarteria.vue?vue&type=template&id=00e9b42e&scoped=true&"
import script from "./BarraDeCarteria.vue?vue&type=script&lang=js&"
export * from "./BarraDeCarteria.vue?vue&type=script&lang=js&"
import style0 from "./BarraDeCarteria.vue?vue&type=style&index=0&id=00e9b42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9b42e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
